import { useEffect } from 'react';
import { router, useLocalSearchParams } from 'expo-router';

export default function ResetPasswordScreen() {
  const params = useLocalSearchParams<{ email?: string }>();

  useEffect(() => {
    router.replace({
      pathname: '/forgot-password',
      params: params.email ? { email: params.email } : undefined,
    });
  }, [params.email]);

  return null;
}
